<template>
    <div class="report-top-bar" :class="'cow-b-'+userPageData.titleClass">
        <div class="report-top-back" @click="clickBack"><span></span></div>
        <div class="report-top-title" :class="'cow-t-'+userPageData.titleClass"></div>
        <div class="report-top-cow" :class="'cow-'+userPageData.titleClass"></div>
        <div class="report-top-popup" :class="'pop-'+userPageData.titleClass">
            <div class="report-light" :class="{'ani': type=='report'}"></div>
            <div class="report-top-score" :class="'score-'+userPageData.titleClass+' '+type">
                <span v-if="userPageData.scoreArr" class="report-s-num" :class="'num'+userPageData.scoreArr[0]"></span>
                <span v-if="userPageData.scoreArr" class="report-s-num" :class="'num'+userPageData.scoreArr[1]"></span>
                <span v-if="userPageData.scoreArr && userPageData.scoreArr.length > 2" class="report-s-num" :class="'num'+userPageData.scoreArr[2]"></span>
                <span class="report-score">分</span>
            </div>
            <div v-if="userPageData.des" class="report-top-content" :class="type">
                <div class="report-text"><span class="report-text1">{{userPageData.des[0]}}</span></div>
                <div class="report-text report-text-two clearfix">
                    <img class="report-text-img" src="http://m1.2048.net/duoniu/images_vehicle/code.png" alt="">
                    <span class="report-text2">{{userPageData.des[1]}}</span>
                </div>
            </div>
            <!-- <div v-if="type=='report'" class="report-top-button-box"> -->
                <!-- 已经授权的话，就直接生成 -->
                <!-- <button class="report-button button1" @click="clickShare">生成图片</button> -->
                <!-- <button class="report-button button2" @click="clickShowShare"><i class="iconfont icon-share"></i>分享 -->
                    <!-- <div v-if="reportShowTip" class="report-button-tip"></div> -->
                <!-- </button> -->
            <!-- </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'ReportTopBar',
    props: {
        type: {
            type: String,
            default: 'report'
        }
    },
    computed: {
        userInfo() {
            return this.$store.state.userData.info;
        },
        userPageData() {
            return this.$store.state.user.userPageData;
        },
        reportShowTip() {
            return this.$store.state.user.reportShowTip;
        }
    },
    mounted() {
        
    },
    methods: {
        clickBack() {
            this.$router.replace('/record');
        },
        clickShare() {
            this.$router.replace('/reportshare')
        },
        clickShowShare() {
            this.$store.state.user.reportShowShare = true;
        }
    }
}
</script>